import React from 'react';
import './button.scss';
import wsp from '../../assets/images/whatsapp/wsp.png'

const ButtonWhatsapp = () => {
      return (
            <a href="https://wa.link/cgn7fi" target="_blank" rel="noopener noreferrer" className="button-whatsapp-container" >
                  <div className="button-whatsapp">
                        <img src={wsp} alt="iconoWhatsapp" />
                        <p className="chateame">Chateanos</p>
                  </div>
            </a>
      );
}

export default ButtonWhatsapp;